import React from 'react';
import { Table as TableAD } from 'antd';
import './Table.less';

function Table(props) {
  // eslint-disable-next-line react/prop-types
  const { ...restProps } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <TableAD size="large" {...restProps} />
  );
}

export default Table;
